import { render, staticRenderFns } from "./FIRs.vue?vue&type=template&id=32177344&scoped=true&"
import script from "./FIRs.vue?vue&type=script&lang=js&"
export * from "./FIRs.vue?vue&type=script&lang=js&"
import style0 from "./FIRs.vue?vue&type=style&index=0&id=32177344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32177344",
  null
  
)

export default component.exports